import { useState, useMemo } from "react";
import Reveal from "../Reveal";

export default function Savings() {
  const [bill, setBill] = useState(6000);
  const { monthly, yearly, twentyFive, kw } = useMemo(() => {
    const offset = 0.9;
    const monthly = Math.round(bill * offset);
    const yearly = monthly * 12;
    const twentyFive = yearly * 25;
    const kw = Math.max(1, Math.round((bill / 1000) * 1.1));
    return { monthly, yearly, twentyFive, kw };
  }, [bill]);

  const fmt = (n) => "₹" + n.toLocaleString("en-IN");

  return (
    <section id="savings" data-testid="savings" className="bg-obsidian py-24 text-cream md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid gap-16 lg:grid-cols-2 lg:items-center">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-gold">Savings calculator</p>
            <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight md:text-5xl">
              See what the sun could save you.
            </h2>
            <p className="mt-5 max-w-md leading-relaxed text-cream/60">
              Drag your average monthly electricity bill. We'll estimate your recommended system size and lifetime savings across 25 years.
            </p>

            <div className="mt-12">
              <div className="mb-3 flex items-end justify-between">
                <span className="text-xs uppercase tracking-widest text-cream/50">Your monthly bill</span>
                <span data-testid="savings-bill" className="font-mono text-2xl font-semibold text-gold">{fmt(bill)}</span>
              </div>
              <input data-testid="savings-slider" type="range" min="1000" max="30000" step="500" value={bill}
                onChange={(e) => setBill(Number(e.target.value))}
                className="h-2 w-full cursor-pointer appearance-none rounded-full bg-white/10 accent-gold"
                style={{ accentColor: "#E69C24" }} />
              <div className="mt-2 flex justify-between font-mono text-xs text-cream/40"><span>₹1k</span><span>₹30k</span></div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="grid grid-cols-2 gap-4">
              <Metric label="Recommended system" value={`${kw} kW`} span />
              <Metric label="Monthly saving" value={fmt(monthly)} />
              <Metric label="Yearly saving" value={fmt(yearly)} />
              <Metric label="25-year saving" value={fmt(twentyFive)} highlight span />
            </div>
            <a href="#quote" data-testid="savings-cta"
              className="mt-6 block w-full rounded-full bg-gold py-4 text-center font-semibold text-obsidian transition-transform duration-300 hover:scale-[0.98] hover:bg-gold-hover">
              Get an exact quote for my roof
            </a>
            <p className="mt-3 text-center text-xs text-cream/40">*Estimates only. Actual savings depend on roof, shading and tariff.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function Metric({ label, value, highlight, span }) {
  return (
    <div className={`rounded-3xl border border-white/10 p-6 ${highlight ? "bg-gold text-obsidian" : "bg-white/5"} ${span ? "col-span-2" : ""}`}>
      <p className={`text-xs uppercase tracking-widest ${highlight ? "text-obsidian/70" : "text-cream/50"}`}>{label}</p>
      <p className={`mt-2 font-heading text-3xl font-extrabold md:text-4xl ${highlight ? "text-obsidian" : "text-cream"}`}>{value}</p>
    </div>
  );
}
